import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { toast } from 'sonner';

import type { Memory } from '../../types/memory';

const MemorySharingShareLink: React.FC<{ memory: Memory }> = ({ memory }) => {
  const [copied, setCopied] = useState(false);

  const handleEmailLink = () => {
    copy(memory.short_url);
    setCopied(true);
    toast.success('Share link copied to clipboard!');
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <wa-card className="memory-sharing-card memory-sharing-share-link" onClick={handleEmailLink}>
      <div className="wa-flank">
        <div className="wa-cluster">
          <div className="memory-sharing-icon">
            <i className="fa-light fa-link" />
          </div>
          <div className="memory-sharing-content">
            {copied ? 'Link copied!' : 'Copy share link'}
          </div>
        </div>
        <div className="memory-sharing-arrow">
          <i className="fa-light fa-chevron-right fa-xs" />
        </div>
      </div>
    </wa-card>
  );
}

export default MemorySharingShareLink;
